import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Route, BrowserRouter, Switch } from 'react-router-dom';
import Feed from './containers/feed';
import store, { history } from './store';
import getUser from './actions/GetUser';
import getFeatureFlags from './actions/GetFeatureFlags';
import getMarkets from './actions/GetMarkets';
import getActivities from './actions/GetActivities';
import getCurrentTeam from './actions/GetCurrentTeam';
import getOpportunityCount from './actions/GetOpportunityCount';
import getMqlPlusCopy from './actions/GetMqlPlusCopy';
import getMqlPlusPricing from './actions/GetMqlPlusPricing';
import getFeatures from './actions/GetFeatures';
import addProductToTeam from './actions/product-management/AddProductToTeam';
import Modal from './containers/modal';
import SmallModal from './containers/small-modal';
import Widget from './containers/widget';
import '../js/bootstrap';
import redirect from './tools/page-redirector';
import { Message } from 'prospect-path-components';

import CmsNav from './components/CmsNav.jsx';
import CmsFooter from './components/CmsFooter.jsx';
import MqlPlusActivation from "./components/MqlPlusActivation";
import MqlPlusIntroduction from "./components/MqlPlusIntroduction";
import LoginFeatures from './components/LoginFeatures';
import CategorySelector from './components/product-management/category-selector';
import DataValueSelector from './components/product-management/data-value-selector';
import PaymentTypeSelector from './components/billing/payment-type-selector';

import SignUp from './pages/register/sign-up';
import CheckEmail from './pages/register/check-email';
import JoinTeam from './pages/register/join-team';
import Home from './pages/home/home';
import BlankLeadPage from './pages/blank-states/leads';
import BlankCampaignsPage from './pages/blank-states/campaigns';
import BlankIntentDataPage from './pages/blank-states/intent-data';

import ProductOverview from './pages/product-management/product-overview';
import YourProducts from './pages/product-management/your-products';
import Team from './pages/team';
import TeamProducts from './pages/product-management/team-products';
import TeamAddProducts from './pages/product-management/team-add-products';
import TeamUsers from './pages/team-users';
import TeamExpanded from './pages/product-management/team-expanded';
import Promote from './pages/product-management/promote';
import Awards from './pages/product-management/awards';
import getVendor from './actions/GetVendor';
import getTeams from './actions/GetTeams';
import NotFound from './pages/not-found';
import ProductManagementFeatures from './components/product-management/ProductManagementFeatures';
import getCurrentTeamId from './actions/product-management/GetCurrentTeamId';
import getNextStepProgress from './actions/GetNextStepProgress';
import getVendorProducts from './actions/product-management/GetVendorProducts';
import BannerContainer from './components/BannerContainer';
import getTeamProducts from './actions/product-management/GetTeamProducts';
import getProductMeta from './actions/product-management/GetProductMeta';
import Success from './pages/register/success';

const pagesWithNoUserData = [
  '/login',
  '/signup',
  '/password/reset',
];

if (!pagesWithNoUserData.includes(window.location.pathname) &&
!window.location.pathname.startsWith('/password/reset') &&
!(window.location.pathname.indexOf('users') !== -1 &&
window.location.pathname.indexOf('single-use-link') !== -1)
) {
  store.dispatch(getMqlPlusCopy());
  store.dispatch(getUser());
  store.dispatch(getFeatureFlags());
  store.dispatch(getTeams());
  store.dispatch(getVendor());
  store.dispatch(getVendorProducts());
  store.dispatch(getFeatures());
}

window.store = store;
window.addProductToTeam = addProductToTeam;

// Render the main feed
if (document.getElementById('main-feed')) {
  store.dispatch(getMarkets());
  store.dispatch(getActivities());
  store.dispatch(getOpportunityCount());
  store.dispatch(getNextStepProgress());
  store.dispatch(getProductMeta());

  const team = store.dispatch(getCurrentTeam());

  store.dispatch(getTeamProducts(team.id));

  redirect();

  ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>
        <div style={{ display: 'flex' }}>
          <CmsNav />
          <div style={{ flex: '1 1 0%' }}>
            <BannerContainer />
              <Switch>
                <Route exact path="/home" render={() => <Home />} />
                <Route exact path="/leads" render={() => window.location.replace('/leads/available')} />
                <Route exact path="/leads/available" render={() => <Feed page="available" />} />
                <Route exact path="/leads/purchased" render={() => <Feed page="purchased" />} />
                <Route exact path="/leads/archived" render={() => <Feed page="archived" />} />
                <Route exact path="/leads/:id" render={props => <Feed lead_id={props.match.params.id} />} />
              </Switch>
            <Modal />
            <SmallModal />
          </div>
        </div>
      </Router>
    </Provider>,
    document.getElementById('main-feed'),
  );
}

// Render the widget
if (document.getElementById('widget-bottom')) {
  store.dispatch(getOpportunityCount());

  ReactDOM.render(
    <Provider store={store}>
      <Widget />
    </Provider>,
    document.getElementById('widget-bottom'),
  );
}

// Render the forgot password component
// this will be implemented later
// ReactDOM.render(
//   <Provider store={store}>
//     <PasswordResetModal />
//   </Provider>,
//   document.getElementById('forgot-password-modal'),
// );

// Render the nav
if (document.getElementById('nav')) {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <CmsNav />
      </BrowserRouter>
    </Provider>,
    document.getElementById('nav'),
  );
}

// Render the MQL+ introduction
if (document.getElementById('mqlPlusIntro')) {
  store.dispatch(getMqlPlusPricing());
  store.dispatch(getCurrentTeam());

  ReactDOM.render(
    <Provider store={store}>
      <MqlPlusIntroduction />
    </Provider>,
    document.getElementById('mqlPlusIntro'),
  );
}

// Render the login feature list
if (document.getElementById('loginFeatureList')) {
  ReactDOM.render(
    <LoginFeatures />,
    document.getElementById('loginFeatureList'),
  );
}

// Render the product management feature list
if (document.getElementById('productManagementFeatureList')) {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <ProductManagementFeatures />
      </BrowserRouter>
    </Provider>,
    document.getElementById('productManagementFeatureList'),
  );
}

// Render the MQL+ activation
if (document.getElementById('mqlPlusActivation')) {
  ReactDOM.render(
    <Provider store={store}>
      <MqlPlusActivation mqlPlusLeadCount={window.mqlPlusLeadCount} />
    </Provider>,
    document.getElementById('mqlPlusActivation'),
  );
}

// Render the footer
if (document.getElementById('cmsFooter')) {
  ReactDOM.render(<CmsFooter />, document.getElementById('cmsFooter'));
}

if (document.getElementById('banner-container')) {
    ReactDOM.render(
        <Provider store={store}>
            <BannerContainer />
        </Provider>,
        document.getElementById('banner-container'),
    );
}

// Render the product management sign up component
// Render the product management component
if (document.getElementById('product-management-signup')) {
  let promises = [];
  if (window.user.id) {
    promises = [
      store.dispatch(getTeams()),
      store.dispatch(getVendor()),
    ];
  }
  Promise.all(promises).then(() => {
    redirect();
    ReactDOM.render(
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            <Route
              exact
              path="/signup/product/teams"
              render={() => <Team />}
            />
            <Route
              exact
              path="/signup/product/teams/:team_id(\d+)"
              render={() => <TeamProducts />}
            />
            <Route path="/*" render={() => <NotFound />} />
          </Routes>
        </BrowserRouter>
      </Provider>,
      document.getElementById('signup'),
    );
  });
}

// Render the signup component
if (document.getElementById('register-page')) {
    const markets = window.markets || [];
    const currencies = window.currencies || [];
    let promises = [];
    if (window.user.id) {
        promises = [
            store.dispatch(getTeams()),
            store.dispatch(getVendor()),
            store.dispatch(getProductMeta()),
        ];
    }
    Promise.all(promises).then(() => {
        ReactDOM.render(
            <Provider store={store}>
              <BrowserRouter>
                <Switch>
                  <Route
                    exact
                    path="/signup"
                    render={() => <SignUp markets={markets} currencies={currencies} />}
                  />
                  <Route
                    exact
                    path="/signup/success"
                    render={() => <Success />}
                  />
                  <Route
                    exact
                    path="/signup/check-email"
                    render={() => <CheckEmail />}
                  />
                  <Route
                    exact
                    path="/signup/teams"
                    render={() => <JoinTeam inactive={!!window.inactive} />}
                  />
                  <Route path="/*" render={() => <NotFound />} />
                  <BannerContainer />
                </Switch>
              </BrowserRouter>
            </Provider>,
            document.getElementById('register-page')
        );
    });
}

// Render the product management component
if (document.getElementById('product-management')) {
  Promise.all([
    store.dispatch(getTeams(window.location.pathname === '/products')),
    store.dispatch(getVendor()),
    store.dispatch(getCurrentTeamId()),
    store.dispatch(getProductMeta()),
  ]).then(() => {
    redirect();
    ReactDOM.render(
      <Provider store={store}>
        <Router history={history}>
          <Switch>
            <Route
              exact
              path="/products"
              render={() => <YourProducts />}
            />
            <Route
              exact
              path="/products/users"
              render={() => <TeamUsers />}
            />
            <Route
              exact
              path="/products/add"
              render={() => <TeamAddProducts />}
            />
            <Route
              exact
              path="/products/:product_id(\d+)"
              render={() => <ProductOverview />}
            />
            <Route
              exact
              path="/products/:product_id(\d+)/promote"
              render={() => <Promote />}
            />
            <Route
              exact
              path="/products/:product_id(\d+)/awards"
              render={() => <Awards />}
            />
            <Route path="/*" render={() => <NotFound />} />
          </Switch>
        </Router>
      </Provider>,
      document.getElementById('product-management'),
    );
  });
}

// Render the product management page
if (document.getElementById('productManagement')) {
  ReactDOM.render(
    (
      <div>
        <CategorySelector />
        <br />
        <DataValueSelector dataGroupSlug="features" />
      </div>
    ), document.getElementById('productManagement'),
  );
}

// Render the product management sign up page
if (document.getElementById('productManagementSignUp')) {
  ReactDOM.render(
    (
      <div>
        <ProductManagementSignUp />
      </div>
    ), document.getElementById('productManagementSignUp'),
  );
}

// Render the product management sign up page
if (document.getElementById('productManagementTeam')) {
  // Load in the category data
  store.dispatch(getProductMeta());

  ReactDOM.render(
    (
      <div>
        <Team />
      </div>
    ), document.getElementById('productManagementTeam'),
  );
}

// Render the product management team products page
if (document.getElementById('productManagementTeamProducts')) {
  ReactDOM.render(
    (
      <div>
        <TeamProducts />
      </div>
    ), document.getElementById('productManagementTeamProducts'),
  );
}

// Render the product management team expanded page
if (document.getElementById('productManagementTeamExpanded')) {
  ReactDOM.render(
    (
      <div>
        <TeamExpanded />
      </div>
    ), document.getElementById('productManagementTeamExpanded'),
  );
}

// Render the product management product overview page
if (document.getElementById('productManagementProductOverview')) {
  ReactDOM.render(
    (
      <div>
        <ProductOverview />
      </div>
    ), document.getElementById('productManagementProductOverview'),
  );
}

// Render the product management your products page
if (document.getElementById('productManagementYourProducts')) {
  ReactDOM.render(
    (
      <div>
        <YourProducts />
      </div>
    ), document.getElementById('productManagementYourProducts'),
  );
}

// Render the product management promote page
if (document.getElementById('productManagementPromote')) {
  ReactDOM.render(
    (
      <div>
        <Promote />
      </div>
    ), document.getElementById('productManagementPromote'),
  );
}

// Render the product management awards page
if (document.getElementById('productManagementAwards')) {
  ReactDOM.render(
    (
      <div>
        <Awards />
      </div>
    ), document.getElementById('productManagementAwards'),
  );
}

// Render the product management pending email page
if (document.getElementById('productManagementPendingEmail')) {
  ReactDOM.render(
    (
      <div>
        <PendingEmail />
      </div>
    ), document.getElementById('productManagementPendingEmail'),
  );
}

// Render blank pages
if (document.getElementById('blankStateLead')) {
  ReactDOM.render(
    (
      <Provider store={store}>
        <BlankLeadPage />
      </Provider>
    ), document.getElementById('blankStateLead'),
  );
}
if (document.getElementById('blankStateCampaign')) {
  ReactDOM.render(
    (
      <Provider store={store}>
        <BlankCampaignsPage />
      </Provider>
    ), document.getElementById('blankStateCampaign'),
  );
}
if (document.getElementById('blankStateIntentData')) {
  ReactDOM.render(
    (
      <Provider store={store}>
        <BlankIntentDataPage />
      </Provider>
    ), document.getElementById('blankStateIntentData'),
  );
}

// Render an alert message
if (document.getElementById('alert-message')) {
  const alertElement = document.getElementById('alert-message');
  ReactDOM.render(
    (
      <Message showClose={false} color={alertElement.dataset.color}><span className="t">{alertElement.dataset.text}</span></Message>
    ),
    alertElement,
  );
}

if (document.getElementById('payment-type-selector')) {
  const paymentTypeSelectorElement = document.getElementById('payment-type-selector');
  const team = window.team;
  const teamIsSelfServed = !!window.teamIsSelfServed;
  const paymentMethods = window.paymentMethods;
  const layout = paymentTypeSelectorElement.dataset.layout || 'default';

  ReactDOM.render(
    <PaymentTypeSelector
        team={team}
        paymentMethods={paymentMethods}
        teamIsSelfServed={teamIsSelfServed}
        layout={layout}
    />,
    paymentTypeSelectorElement,
  );
}
